import getIn from 'transmute/getIn';
export const getIndexedAsyncVisitors = getIn(['threadViewRootReducer', 'visitors']);